import { render } from "./TermsGate.vue?vue&type=template&id=295b127e&scoped=true"
import script from "./TermsGate.vue?vue&type=script&lang=js"
export * from "./TermsGate.vue?vue&type=script&lang=js"

import "./TermsGate.vue?vue&type=style&index=0&id=295b127e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295b127e"]])

export default __exports__